import url from 'url';
import { webServerHostUrl } from './url_util';

import { replaceXSSText } from './security';
import { EC_ENUM } from '../constants/product';
// private
const BASE_META_TAGS_STRING =
  '<meta name="copyright" content="Funliday Inc."/>' +
  '<meta property="fb:app_id" content="481027911976374"/>';

const BASE_META_TAGS_STRING_OG_TYPE_WEBSITE =
  '<meta property="og:type" content="website" />';

const BASE_META_TAGS_STRING_OG_TYPE_ARTICLE =
  '<meta property="og:type" content="article" />';

const HREF_LANG_LINKS = ['zh-cn', 'zh-tw', 'ja', 'ko', 'en'];

const BASE_META_TAGS_STRING_OG_SITE_NAME = `<meta property="og:site_name" content="Funliday" />`;

const getNameByLanguage = (urlPath, language) => {
  const canonicalLink = webServerHostUrl() + urlPath.substring(1);
  const hrefLangLinks = getHrefLangLinks(canonicalLink);

  const title = getTitle(language);
  const ogUrl = `${canonicalLink}`;

  return `
    <title>${title}</title>
    <meta property="og:title" content="${title}" />
    <meta property="og:url" content="${ogUrl}" />
    <link rel="canonical" href="${canonicalLink}" />
    <meta name="google-site-verification" content="gvfTaoEUbWodQLqH1iVkkZPm3UP0je4MC3spFgXqj44" />
    ${hrefLangLinks}
  `;
};

const getHrefLangLinks = canonicalLink => {
  let hrefLangLinks = '';

  HREF_LANG_LINKS.forEach(lang => {
    const urlParts = url.parse(canonicalLink, true);

    urlParts.query.hl = lang;

    const hrefLangLink = url
      .format({
        protocol: urlParts.protocol,
        host: urlParts.host,
        pathname: urlParts.pathname,
        query: urlParts.query,
        slashes: true
      })
      .replace('https:///', 'https://');

    hrefLangLinks += `<link rel="alternate" href="${hrefLangLink}" hreflang="${lang}" />`;
  });

  hrefLangLinks += `<link rel="alternate" href="${canonicalLink}" hreflang="x-default" />`;

  return hrefLangLinks;
};

const getOGImageByLanguage = language => {
  switch (language) {
    case 'zh-cn': {
      return '<meta property="og:image" content="https://assets.funliday.com/og-image/ogimage_zh_cn.jpg" />';
    }
    case 'zh-tw': {
      return '<meta property="og:image" content="https://assets.funliday.com/og-image/ogimage_zh_tw.jpg" />';
    }
    case 'ja': {
      return '<meta property="og:image" content="https://assets.funliday.com/og-image/ogimage_ja.jpg" />';
    }
    case 'ko': {
      return '<meta property="og:image" content="https://assets.funliday.com/og-image/ogimage_ko.jpg" />';
    }
    default: {
      return '<meta property="og:image" content="https://assets.funliday.com/og-image/ogimage_en.jpg" />';
    }
  }
};
export const getImage = language => {
  switch (language) {
    case 'zh-cn': {
      return 'https://assets.funliday.com/og-image/ogimage_zh_cn.jpg';
    }
    case 'zh-tw': {
      return 'https://assets.funliday.com/og-image/ogimage_zh_tw.jpg';
    }
    case 'ja': {
      return 'https://assets.funliday.com/og-image/ogimage_ja.jpg';
    }
    case 'ko': {
      return 'https://assets.funliday.com/og-image/ogimage_ko.jpg';
    }
    default: {
      return 'https://assets.funliday.com/og-image/ogimage_en.jpg';
    }
  }
};

const getItempropImageByLanguage = language => {
  switch (language) {
    case 'zh-cn': {
      return '<meta itemprop="image" content="https://assets.funliday.com/og-image/ogimage_zh_cn.jpg" />';
    }
    case 'zh-tw': {
      return '<meta itemprop="image" content="https://assets.funliday.com/og-image/ogimage_zh_tw.jpg" />';
    }
    case 'ja': {
      return '<meta itemprop="image" content="https://assets.funliday.com/og-image/ogimage_ja.jpg" />';
    }
    case 'ko': {
      return '<meta itemprop="image" content="https://assets.funliday.com/og-image/ogimage_ko.jpg" />';
    }
    default: {
      return '<meta itemprop="image" content="https://assets.funliday.com/og-image/ogimage_en.jpg" />';
    }
  }
};

const getOGDescriptionTagByLanguage = language => {
  let description;

  switch (language) {
    case 'zh-cn': {
      description =
        'Funliday 提供最棒的旅游行程规划工具，支援 iOS、Android 和电脑版。一切只要轻松拖拉就会自动帮您规划出完整的路径并计算交通时间。';

      break;
    }
    case 'zh-tw': {
      description =
        'Funliday 提供最棒的旅遊行程規劃工具，支援 iOS、Android 和電腦版。一切只要輕鬆拖拉就會自動幫您規劃出完整的路徑並計算交通時間。';

      break;
    }
    case 'ja': {
      description =
        'Funlidayはあなたが最高の旅行計画を立てるのをお手伝いをします。iOS、Android、そしてパソコンに対応。ドラッグ＆ドロップするだけで、Funlidayが完璧なルートと移動時間を計算してプランを立ててくれます。';

      break;
    }
    case 'ko': {
      description =
        'Funliday는 로컬 관광명소와 길을 찾고 여행계획들을 쉽게 관리함으로 당신의 여행을 훨씬 편하게 만들어주는 여행계획 앱입니다. Funliday는 iOS와 안드로이드뿐 아니라 웹도 지원합니다. Funliday 수천개의 목적지를 제공함으로 모든 장소를 쉽게 탐색하 여행일정에 추가할 수 있습니다. 또한 일정 경로를 구성하고 여행에 필요한 모든 유요 정보에 접근할 수 있습니다.';

      break;
    }
    default: {
      description =
        'Funliday is the best trip planning app that makes your trip easier. We support iOS, Android and desktop platforms. You can easily explore all of the places you are interested in and simply add them to your itinerary. You can also organize schedules and routes, as well as access all other useful information for your trip.';

      break;
    }
  }

  return `
    <meta name="description" content="${description}" />
    <meta property="og:description" content="${description}" />
    <meta itemprop="description" content="${description}" />
  `;
};

export const getDescription = language => {
  let description;

  switch (language) {
    case 'zh-cn': {
      description =
        'Funliday 提供最棒的旅游行程规划工具，支援 iOS、Android 和电脑版。一切只要轻松拖拉就会自动帮您规划出完整的路径并计算交通时间。';

      break;
    }
    case 'zh':
    case 'zh-tw': {
      description =
        'Funliday 提供最棒的旅遊行程規劃工具，支援 iOS、Android 和電腦版。一切只要輕鬆拖拉就會自動幫您規劃出完整的路徑並計算交通時間。';

      break;
    }
    case 'ja': {
      description =
        'Funlidayはあなたが最高の旅行計画を立てるのをお手伝いをします。iOS、Android、そしてパソコンに対応。ドラッグ＆ドロップするだけで、Funlidayが完璧なルートと移動時間を計算してプランを立ててくれます。';

      break;
    }
    case 'ko': {
      description =
        'Funliday는 로컬 관광명소와 길을 찾고 여행계획들을 쉽게 관리함으로 당신의 여행을 훨씬 편하게 만들어주는 여행계획 앱입니다. Funliday는 iOS와 안드로이드뿐 아니라 웹도 지원합니다. Funliday 수천개의 목적지를 제공함으로 모든 장소를 쉽게 탐색하 여행일정에 추가할 수 있습니다. 또한 일정 경로를 구성하고 여행에 필요한 모든 유요 정보에 접근할 수 있습니다.';

      break;
    }

    default: {
      description =
        'Funliday is the best trip planning app that makes your trip easier. We support iOS, Android and desktop platforms. You can easily explore all of the places you are interested in and simply add them to your itinerary. You can also organize schedules and routes, as well as access all other useful information for your trip.';

      break;
    }
  }

  return description;
};

export const getOGPPOIDescriptionByLanguage = (language, POIs) => {
  const travelDays = Object.keys(POIs);
  const checkDayLanguage = index => {
    switch (language) {
      case 'zh-cn': {
        return `[第${index}天]`;
      }
      case 'zh-tw': {
        return `[第${index}天]`;
      }
      case 'zh': {
        return `[第${index}天]`;
      }
      case 'zh-hk': {
        return `[第${index}天]`;
      }
      case 'ja': {
        return `[第${index}日]`;
      }
      case 'ko': {
        return `[제${index}일]`;
      }
      default: {
        return `[Day ${index}]`;
      }
    }
  };
  const removeQuotationMark = (txt = '') => {
    let newTxt = txt.split("'");
    newTxt = newTxt.join('');
    let newTxt2 = newTxt.split('"');
    newTxt2 = newTxt2.join('');
    return newTxt2;
  };

  let stringPOIs = '';

  travelDays.forEach(item => {
    const Day = checkDayLanguage(item);
    stringPOIs = stringPOIs ? `${stringPOIs} ${Day} ` : `${Day} `;
    POIs[item].forEach((item2, index) => {
      const arrow = index + 1 === POIs[item].length ? '' : ' > ';
      const POILocation = removeQuotationMark(item2.name);
      stringPOIs = `${stringPOIs}${POILocation}${arrow}`;
    });
  });
  return stringPOIs;
};

export const getTripTitle = ({
  nickname,
  title,
  language,
  countries,
  cities,
  dayCount
}) => {
  // 預防 xss
  const encodeTitle = replaceXSSText(title);

  /**
 * 1. 有 cities 有 countries，僅顯示 cities 的內容
 * title 就是「trip name - city1 city2 city3 幾天幾夜 | Funliday XXX」
 *
 * 2. 沒 cities 有 countries，顯示 countries 的內容
 * title 就是「trip name - country1 country2 幾天幾夜 | Funliday XXX」
 *
 * 3. 有 cities 沒 countries，顯示 cities 的內容
 * title 就是「trip name - city1 city2 幾天幾夜 | Funliday XXX」
 *
 * 4. cities、countries 都沒有的話就「trip name 幾天幾夜 | Funliday XXX」

*/
  const HAVA = {
    CITIES: cities && cities.length > 0,
    COUNTRIES: countries && countries.length > 0,
    DAY_COUNT: dayCount
  };

  const appName = nickname
    ? `${nickname}@${getItineraryTitleByLanguage(language)}`
    : getItineraryTitleByLanguage(language);
  let tripTitle = `${encodeTitle} `;

  if (HAVA.CITIES && HAVA.COUNTRIES) {
    tripTitle += '- ';
    cities.forEach(item => {
      tripTitle += `${item.name} `;
    });
  }

  if (!HAVA.CITIES && HAVA.COUNTRIES) {
    tripTitle += '- ';
    countries.forEach(item => {
      tripTitle += `${item.name} `;
    });
  }

  if (HAVA.CITIES && !HAVA.COUNTRIES) {
    tripTitle += '- ';
    cities.forEach(item => {
      tripTitle += `${item.name} `;
    });
  }

  if (HAVA.DAY_COUNT) {
    tripTitle += getDayAndNight(language, dayCount);
  }
  tripTitle += `| ${appName}`;

  return tripTitle;
};

// public methods
export const defaultMetaTagsString = (urlPath, language) => {
  const metaString =
    getNameByLanguage(urlPath, language) +
    getOGImageByLanguage(language) +
    getItempropImageByLanguage(language) +
    getOGDescriptionTagByLanguage(language);

  return (
    BASE_META_TAGS_STRING +
    BASE_META_TAGS_STRING_OG_TYPE_WEBSITE +
    BASE_META_TAGS_STRING_OG_SITE_NAME +
    metaString
  );
};

export const metaTagString = ({
  urlPath,
  title,
  images,
  description,
  language,
  size,
  pois,
  noindex
}) => {
  let string = BASE_META_TAGS_STRING;
  string += BASE_META_TAGS_STRING_OG_SITE_NAME;
  string += BASE_META_TAGS_STRING_OG_TYPE_ARTICLE;

  // 預防 xss
  const encodeTitle = replaceXSSText(title);

  const appName = getTitle(language);
  const fullTitle = `${encodeTitle} | ${appName}`;
  string += `<title>${fullTitle}</title>`;
  string += `<meta property="og:title" content="${fullTitle}" />`;

  if (noindex) {
    string += `<meta name="robots" content="noindex" />`;
  }

  if (description && description.length !== 0) {
    string += `<meta name="description" content="${description}" /><meta property="og:description" content="${description}" />`;
  } else if (pois && pois[1] && pois[1].length !== 0) {
    const stringPOIsDescription = getOGPPOIDescriptionByLanguage(
      language,
      pois
    );
    string += `<meta name="description" content="${stringPOIsDescription}" />
    <meta property="og:description" content="${stringPOIsDescription}" />`;
  } else {
    string += getOGDescriptionTagByLanguage(language);
  }

  const ogImageResult = buildOGImage(string, images, size);

  const imageCount = ogImageResult.imageCount;

  string = ogImageResult.imageMeta;

  if (imageCount === 0) {
    string +=
      getOGImageByLanguage(language) + getItempropImageByLanguage(language);
  }

  if (urlPath) {
    const canonicalLink = webServerHostUrl() + urlPath.substring(1);
    const hrefLangLinks = getHrefLangLinks(canonicalLink);
    const ogUrl = `${canonicalLink}?hl=${language}`;

    string += `
      <meta property="og:url" content="${ogUrl}" />
      <link rel="canonical" href="${canonicalLink}" />
      ${hrefLangLinks}
    `;
  }

  return string;
};

export const discoverMetaTagString = ({
  urlPath,
  title,
  images,
  description,
  language,
  size,
  pois,
  noindex
}) => {
  let string = BASE_META_TAGS_STRING;
  string += BASE_META_TAGS_STRING_OG_SITE_NAME;
  string += BASE_META_TAGS_STRING_OG_TYPE_ARTICLE;

  // 預防 xss
  // const encodeTitle = replaceXSSText(title);

  const appName = getTitle(language);
  const fullTitle = `${title} | ${appName}`;
  string += `<title>${fullTitle}</title>`;
  string += `<meta property="og:title" content="${fullTitle}" />`;

  if (noindex) {
    string += `<meta name="robots" content="noindex" />`;
  }

  if (description && description.length !== 0) {
    string += `<meta name="description" content="${description}" /><meta property="og:description" content="${description}" />`;
  } else if (pois && pois[1] && pois[1].length !== 0) {
    const stringPOIsDescription = getOGPPOIDescriptionByLanguage(
      language,
      pois
    );
    string += `<meta name="description" content="${stringPOIsDescription}" />
    <meta property="og:description" content="${stringPOIsDescription}" />`;
  } else {
    string += getOGDescriptionTagByLanguage(language);
  }

  const ogImageResult = buildOGImage(string, images, size);

  const imageCount = ogImageResult.imageCount;

  string = ogImageResult.imageMeta;

  if (imageCount === 0) {
    string +=
      getOGImageByLanguage(language) + getItempropImageByLanguage(language);
  }

  if (urlPath) {
    const ogUrl = webServerHostUrl() + urlPath.substring(1);
    string += `
      <meta property="og:url" content="${ogUrl}" />
      <meta http-equiv="content-language" content="${language}">
      <link rel="canonical" href="${webServerHostUrl()}" />
      <link rel="alternate" href="${webServerHostUrl()}tw" hreflang="zh-tw" />
      <link rel="alternate" href="${webServerHostUrl()}cn" hreflang="zh-cn" />
      <link rel="alternate" href="${webServerHostUrl()}jp" hreflang="ja" />
      <link rel="alternate" href="${webServerHostUrl()}kr" hreflang="ko" />
      <link rel="alternate" href="${webServerHostUrl()}en" hreflang="en" />
      <link rel="alternate" href="${webServerHostUrl()}en" hreflang="x-default" />
    `;
  }

  return string;
};

export const itineraryMetaTagString = ({
  urlPath,
  title,
  images,
  description,
  language,
  size,
  pois,
  noindex,
  countries,
  cities,
  nickname,
  dayCount
}) => {
  let string = BASE_META_TAGS_STRING;
  string += BASE_META_TAGS_STRING_OG_SITE_NAME;
  string += BASE_META_TAGS_STRING_OG_TYPE_ARTICLE;

  // 預防 xss
  const encodeTitle = replaceXSSText(title);

  if (countries.name || cities.length || dayCount) {
    const fullTitle = getTripTitle({
      title: encodeTitle,
      language,
      countries,
      cities,
      dayCount,
      nickname
    });
    string += `<meta property="og:title" content="${fullTitle}" />`;
  } else {
    const appName = nickname
      ? `${nickname}@${getItineraryTitleByLanguage(language)}`
      : getItineraryTitleByLanguage(language);
    const fullTitle = `${encodeTitle} | ${appName}`;

    string += `<meta property="og:title" content="${fullTitle}" />`;
  }

  if (noindex) {
    string += `<meta name="robots" content="noindex" />`;
  }

  if (description && description.length !== 0) {
    string += `<meta name="description" content="${description}" />
    <meta property="og:description" content="${description}" />`;
  } else if (pois && pois[1] && pois[1].length !== 0) {
    const stringPOIsDescription = getOGPPOIDescriptionByLanguage(
      language,
      pois
    );
    string += `<meta name="description" content="${stringPOIsDescription}" />
    <meta property="og:description" content="${stringPOIsDescription}" />`;
  } else {
    string += getOGDescriptionTagByLanguage(language);
  }

  const ogImageResult = buildOGImage(string, images, size);

  const imageCount = ogImageResult.imageCount;

  string = ogImageResult.imageMeta;

  if (imageCount === 0) {
    string +=
      getOGImageByLanguage(language) + getItempropImageByLanguage(language);
  }

  if (urlPath) {
    const canonicalLink = webServerHostUrl() + urlPath.substring(1);
    const { canonicalUrl } = mappingUrl(canonicalLink, language);
    string += `
      <meta property="og:url" content="${canonicalUrl}" />
      <link rel="canonical" href="${canonicalUrl}" />
    `;
  }

  return string;
};

export const journalMetaTagString = ({
  urlPath,
  title,
  images,
  description,
  language,
  size,
  nickname,
  noindex
}) => {
  let string = BASE_META_TAGS_STRING;
  string += BASE_META_TAGS_STRING_OG_SITE_NAME;
  string += BASE_META_TAGS_STRING_OG_TYPE_ARTICLE;

  // 預防 xss
  const encodeTitle = replaceXSSText(title);
  const encodeAuthor = replaceXSSText(nickname);

  const appName = nickname
    ? `${nickname}@${getJournalTitleByLanguage(language)}`
    : getJournalTitleByLanguage(language);
  const fullTitle = `${encodeTitle} | ${appName}`;

  string += `<title>${fullTitle}</title>`;
  string += `<meta property="og:title" content="${fullTitle}" />`;
  string += `<meta name="author" content="${encodeAuthor}">`;
  if (description.length !== 0) {
    string += `<meta property="og:description" content="${replaceXSSText(
      description
    )}" />`;
  } else {
    string += getOGDescriptionTagByLanguage(language);
  }
  if (noindex) {
    string += "<meta name='robots' content='noindex' />";
  }

  const ogImageResult = buildOGImage(string, images, size);

  const imageCount = ogImageResult.imageCount;

  string = ogImageResult.imageMeta;

  if (imageCount === 0) {
    string +=
      getOGImageByLanguage(language) + getItempropImageByLanguage(language);
  }

  if (urlPath) {
    const canonicalLink = webServerHostUrl() + urlPath.substring(1);
    const { canonicalUrl } = mappingUrl(canonicalLink, language);
    string += `
      <meta property="og:url" content="${canonicalUrl}" />
      <link rel="canonical" href="${canonicalUrl}" />
    `;
  }

  return string;
};

const buildOGImage = (string, images, size) => {
  let imageCount = 0;
  let imageMeta = string;

  (images || []).forEach(image => {
    imageCount++;

    imageMeta += `<meta property="og:image" content="${image}" />`;

    if (size) {
      imageMeta += `<meta property="og:image:width" content="${size.width}" />`;
      imageMeta += `<meta property="og:image:height" content="${size.height}" />`;
    }
  });

  return {
    imageCount,
    imageMeta
  };
};

export const getItineraryTitleByLanguage = language => {
  switch (language) {
    case 'zh-cn': {
      return 'Funliday 行程规划地图';
    }
    case 'zh-tw': {
      return 'Funliday 行程規劃地圖';
    }
    case 'zh': {
      return 'Funliday 行程規劃地圖';
    }
    case 'ja': {
      return 'Funliday 旅行計画';
    }
    case 'ko': {
      return 'Funliday 여행계획';
    }
    default: {
      return 'Funliday Travel Planner';
    }
  }
};

export const getJournalTitleByLanguage = language => {
  switch (language) {
    case 'zh-cn': {
      return 'Funliday 游记分享、旅游体验';
    }
    case 'zh-tw': {
      return 'Funliday 遊記分享、旅遊體驗';
    }
    case 'zh': {
      return 'Funliday 遊記分享、旅遊體驗';
    }
    case 'ja': {
      return 'Funliday トラベルゾーン';
    }
    case 'ko': {
      return 'Funliday 여행일기';
    }
    default: {
      return 'Funliday Travel Blog';
    }
  }
};

export const getProductTitleByLanguage = (language, type) => {
  if (type === EC_ENUM.TYPE.CAR_RENTAL) {
    switch (language) {
      case 'zh-cn': {
        return 'Funliday 租车';
      }
      case 'zh-tw': {
        return 'Funliday 租車';
      }
      case 'zh': {
        return 'Funliday 租車';
      }
      case 'ja': {
        return 'Funliday レンタカー';
      }
      case 'ko': {
        return 'Funliday 자동차 임대';
      }
      default: {
        return 'Funliday Car rental';
      }
    }
  }

  switch (language) {
    case 'zh-cn': {
      return 'Funliday 在地体验';
    }
    case 'zh-tw': {
      return 'Funliday 在地體驗';
    }
    case 'zh': {
      return 'Funliday 在地體驗';
    }
    case 'ja': {
      return 'Funliday 体験';
    }
    case 'ko': {
      return 'Funliday 체험';
    }
    default: {
      return 'Funliday Experiences';
    }
  }
};

export const getTitle = language => {
  switch (language) {
    case 'zh-cn': {
      return 'Funliday 规划 • 旅游 • 分享';
    }
    case 'zh-tw': {
      return 'Funliday 規劃 • 旅遊 • 分享';
    }
    case 'zh': {
      return 'Funliday 規劃 • 旅遊 • 分享';
    }
    case 'ja': {
      return 'Funliday 旅行計画、共同編集';
    }
    case 'ko': {
      return 'Funliday 여행계획, 추억 공유하기';
    }
    default: {
      return 'Funliday - Plan trips • Share memories';
    }
  }
};

export const getDayAndNight = (language, dayCount) => {
  const day = Number(dayCount);
  const night = day - 1;
  if (day === 1) {
    switch (language) {
      case 'zh-cn': {
        return `${day}日游 `;
      }
      case 'zh-tw': {
        return `${day}日遊 `;
      }
      case 'zh': {
        return `${day}日遊 `;
      }
      case 'ja': {
        return `${day}日旅行 `;
      }
      case 'ko': {
        return `${day}일 여행 `;
      }
      default: {
        return `${day} day trip `;
      }
    }
  } else {
    switch (language) {
      case 'zh-cn': {
        return `${day}天${night}夜`;
      }
      case 'zh-tw': {
        return `${day}天${night}夜 `;
      }
      case 'zh': {
        return `${day}天${night}夜 `;
      }
      case 'ja': {
        return `${night}泊${day}日 `;
      }
      case 'ko': {
        return `${night}박${day}일 `;
      }
      default: {
        return `${day} days ${night} nights `;
      }
    }
  }
};

export const getCollectionTitleByLanguage = language => {
  switch (language) {
    case 'zh-cn': {
      return 'Funliday 景点收藏';
    }
    case 'zh-tw': {
      return 'Funliday 景點收藏';
    }
    case 'zh-hk': {
      return 'Funliday 景點收藏';
    }
    case 'zh': {
      return 'Funliday 景點收藏';
    }
    case 'ja': {
      return 'Funliday コレクション';
    }
    case 'ko': {
      return 'Funliday 즐겨찾기';
    }
    default: {
      return 'Funliday Collections';
    }
  }
};

export const collectionMetaTagString = ({
  urlPath,
  title,
  image,
  description,
  language,
  size,
  nickname,
  noindex
}) => {
  let string = BASE_META_TAGS_STRING;
  string += BASE_META_TAGS_STRING_OG_SITE_NAME;
  string += BASE_META_TAGS_STRING_OG_TYPE_ARTICLE;

  // 預防 xss
  const encodeTitle = replaceXSSText(title);
  const encodeAuthor = replaceXSSText(nickname);

  const appName = nickname
    ? `${nickname}@${getCollectionTitleByLanguage(language)}`
    : getCollectionTitleByLanguage(language);
  const fullTitle = `${encodeTitle} | ${appName}`;

  string += `<meta name="author" content="${encodeAuthor}">`;
  string += `<meta property="og:title" content="${fullTitle}" />`;
  string += `<meta property="og:image" content="${image}">`;

  const concatUrl = webServerHostUrl() + urlPath.substring(1);
  const { canonicalUrl } = mappingUrl(concatUrl, language);
  string += `<meta property="og:url" content="${canonicalUrl}">`;
  string += `<link rel="canonical" href="${canonicalUrl}" />`;

  if (description && description.length !== 0) {
    string += `<meta property="og:description" content="${replaceXSSText(
      description
    )}" />`;
    string += `<meta name="description" content="${replaceXSSText(
      description
    )}" />`;
  } else {
    string += getOGDescriptionTagByLanguage(language);
  }
  if (noindex) {
    string += "<meta name='robots' content='noindex' />";
  }

  return string;
};

export const articleMetaTagString = ({
  urlPath,
  title,
  image,
  description,
  language,
  size,
  nickname,
  noindex
}) => {
  let string = BASE_META_TAGS_STRING;
  string += BASE_META_TAGS_STRING_OG_SITE_NAME;
  string += BASE_META_TAGS_STRING_OG_TYPE_ARTICLE;

  // 預防 xss
  const encodeTitle = replaceXSSText(title);
  const encodeAuthor = replaceXSSText(nickname);

  const appName = nickname
    ? `${nickname}@${getJournalTitleByLanguage(language)}`
    : getJournalTitleByLanguage(language);
  const fullTitle = `${encodeTitle} | ${appName}`;

  string += `<meta name="author" content="${encodeAuthor}">`;
  string += `<meta property="og:title" content="${fullTitle}" />`;
  string += `<meta property="og:image" content="${image}">`;

  const concatUrl = webServerHostUrl() + urlPath.substring(1);
  const { canonicalUrl } = mappingUrl(concatUrl, language);
  string += `<meta property="og:url" content="${canonicalUrl}">`;
  string += `<link rel="canonical" href="${canonicalUrl}" />`;

  if (description.length !== 0) {
    string += `<meta name="description" content="${replaceXSSText(
      description
    )}" />`;
    string += `<meta property="og:description" content="${replaceXSSText(
      description
    )}" />`;
  } else {
    string += getOGDescriptionTagByLanguage(language);
  }
  if (noindex) {
    string += "<meta name='robots' content='noindex' />";
  }

  return string;
};

export const profileMetaTagString = ({
  urlPath,
  title,
  image,
  description,
  language,
  nickname,
  noindex,
  type
}) => {
  const DEFAULT_COVER_URL =
    'https://assets.funliday.com/users/img_personal_cover_default.png';
  let string = BASE_META_TAGS_STRING;
  string += BASE_META_TAGS_STRING_OG_SITE_NAME;
  string += BASE_META_TAGS_STRING_OG_TYPE_ARTICLE;

  // 預防 xss
  const encodeTitle = replaceXSSText(title);
  const encodeAuthor = replaceXSSText(nickname);

  const appName = getTitle(language);
  const fullTitle = `${encodeTitle} | ${appName}`;

  string += `<meta name="author" content="${encodeAuthor}">`;
  string += `<meta property="og:title" content="${fullTitle}" />`;
  const ogImg =
    image !== DEFAULT_COVER_URL
      ? `<meta property="og:image" content="${image}">`
      : getOGImageByLanguage(language);
  string += ogImg;

  const concatUrl = webServerHostUrl() + urlPath.substring(1);
  const { canonicalUrl } = mappingUrl(concatUrl, language);
  string += `<meta property="og:url" content="${canonicalUrl}">`;
  string += `<link rel="canonical" href="${canonicalUrl}" />`;

  if (description.length !== 0) {
    string += `<meta name="description" content="${replaceXSSText(
      description
    )}" />`;
    string += `<meta property="og:description" content="${replaceXSSText(
      description
    )}" />`;
  } else {
    string += getOGDescriptionTagByLanguage(language);
  }
  if (noindex) {
    string += "<meta name='robots' content='noindex' />";
  }

  return string;
};

/** @method mappingUrl - 組成包含 ogUrl 和 canonicalUrl 的物件且 query ?符號 不會重複帶錯
 * @param {string} link - webServerHostUrl() + urlPath.substring(1) 組出來的網址
 * @param {string} language - 語系
 * @return {object} 包含 ogUrl 和 canonicalUrl 的物件
 */
const mappingUrl = (link, language) => {
  const defaultLang = 'en';
  const handleLang = [...HREF_LANG_LINKS, 'zh'];
  const urlParts = url.parse(link, true);

  const isHandleUrl = handleLang.find(item => item === language);
  urlParts.query.hl = isHandleUrl ? language : defaultLang;

  const ogUrl = url
    .format({
      protocol: urlParts.protocol,
      host: urlParts.host,
      pathname: urlParts.pathname,
      query: urlParts.query,
      slashes: true
    })
    .replace('https:///', 'https://');

  /** @string canonicalUrl - <link rel=canonical /> 所需網址
   * @description 不論 query 或語系參數為何, canonical 用的格式網址應統一僅一個，例如 xxx?q=123 和 xxx?hl=ja 對搜尋引擎來說都應是 xxx 而不是不同的兩頁，以 canonical 固定帶入 query 時的權重
   * @see https://support.google.com/webmasters/answer/139066?hl=zh-Hant
   */
  const canonicalUrl = url
    .format({
      protocol: urlParts.protocol,
      host: urlParts.host,
      pathname: urlParts.pathname,
      slashes: true
    })
    .replace('https:///', 'https://');

  return {
    ogUrl,
    canonicalUrl
  };
};

export const productMetaTagString = ({
  urlPath,
  title,
  image,
  description,
  language,
  nickname,
  noindex,
  type
}) => {
  let string = BASE_META_TAGS_STRING;
  string += BASE_META_TAGS_STRING_OG_SITE_NAME;
  string += BASE_META_TAGS_STRING_OG_TYPE_ARTICLE;

  // 預防 xss
  // const encodeTitle = replaceXSSText(title);
  const encodeAuthor = replaceXSSText(nickname);

  const appName = nickname
    ? `${nickname}@${getProductTitleByLanguage(language, type)}`
    : getProductTitleByLanguage(language, type);
  const fullTitle = `${title} | ${appName}`;

  string += `<meta name="author" content="${encodeAuthor}">`;
  string += `<meta property="og:title" content="${fullTitle}" />`;
  string += `<meta property="og:image" content="${image}">`;

  const concatUrl = webServerHostUrl() + urlPath.substring(1);
  const { canonicalUrl } = mappingUrl(concatUrl, language);
  string += `<meta property="og:url" content="${canonicalUrl}">`;
  string += `<link rel="canonical" href="${canonicalUrl}" />`;

  if (description && description.length !== 0) {
    string += `<meta name="description" content="${replaceXSSText(
      description
    )}" />`;
    string += `<meta property="og:description" content="${replaceXSSText(
      description
    )}" />`;
  } else {
    string += getOGDescriptionTagByLanguage(language);
  }
  if (noindex) {
    string += "<meta name='robots' content='noindex' />";
  }

  return string;
};
